import React, { useRef } from "react";
import { NiceModal } from "@castlery/fortress";
import {
  BUTTON_TAG,
  CLICK_ACTION,
  TRACK_EVENT,
  trackEvent,
} from "@/utils/analytics";

interface WhatsAppProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export const WhatsApp: React.FC<WhatsAppProps> = ({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  onClose,
  containerRef,
}) => {
  const isCanceling = useRef(false);

  const handleConfirm = () => {
    trackEvent({
      event: TRACK_EVENT,
      category: "whatsapp",
      action: CLICK_ACTION,
      tag: BUTTON_TAG,
      tag_value: "confirm",
    });

    onConfirm();
    onOpenChange(false);
  };

  const handleCancel = () => {
    if (isCanceling.current) return;
    isCanceling.current = true;

    trackEvent({
      event: TRACK_EVENT,
      category: "whatsapp",
      action: CLICK_ACTION,
      tag: BUTTON_TAG,
      tag_value: "cancel",
    });

    onCancel();
    onOpenChange(false);
  };

  const handleClose = () => {
    if (isCanceling.current) {
      isCanceling.current = false;
      return;
    }

    trackEvent({
      event: TRACK_EVENT,
      category: "whatsapp",
      action: CLICK_ACTION,
      tag: BUTTON_TAG,
      tag_value: "close",
    });

    onClose();
    onOpenChange(false);
    isCanceling.current = true;
  };

  return (
    <NiceModal
      title="Preparing to open WhatsApp"
      desc="Help customer service assist you faster by sharing your chat history for context."
      open={open}
      onClose={handleClose}
      isSilent={false}
      onConfirm={handleConfirm}
      confirmText="SHARE & OPEN"
      onCancel={handleCancel}
      cancelText="OPEN WITHOUT SHARING"
      container={containerRef?.current}
      disableEnforceFocus={true}
      modalSlotProps={{
        backdrop: { sx: { position: "absolute", inset: 0 } },
        root: { sx: { position: "absolute", inset: 0 } },
      }}
      dialogSx={{
        maxWidth: "90%",
      }}
    />
  );
};
